<template>
  <!-- Barra in cima a ogni pagina (Angelo, 4/11/2026): a sinistra il marchio, a destra i controlli (lingua, tema, notifiche): la lingua è una pillola che a riposo mostra solo la scelta attiva, in terracotta, e col mouse sopra si apre; il tema è l'interruttore giorno/notte. Il profilo resta nel menu laterale.
       `relative z-60`: lo sfondo delle pagine (`AppBackground`, fisso a tutta finestra) e le intestazioni sticky (z-50) la coprirebbero appena la pagina si monta; la tendina della campanella sta dentro questo livello. -->
  <header
    class="glass-strong relative z-60 flex shrink-0 items-center justify-between gap-2 border-b border-glass-border px-3 before:pointer-events-none before:absolute before:inset-x-0 before:bottom-0 before:h-0.5 before:bg-linear-to-r before:from-accent before:via-accent/30 before:to-transparent sm:gap-3 sm:px-4"
    :style="{ height: 'var(--altezza-barra)', paddingTop: 'var(--safe-t)', boxSizing: 'content-box' }"
    role="toolbar"
    :aria-label="t('layout.barra.titolo')"
    data-test="barra-globale"
  >
    <NuxtLink to="/dashboard" class="focusable inline-flex min-w-0 items-center rounded-lg" :aria-label="t('layout.barra.home')" data-test="barra-marchio">
      <AppLogo wordmark compatto class="max-sm:hidden" />
      <AppLogo compatto class="sm:hidden" />
    </NuxtLink>

    <div class="flex shrink-0 items-center gap-1.5 sm:gap-3">
      <LayoutBarraToggle :model-value="locale" :options="opzioniLingua" :aria-label="t('layout.barra.lingua')" data-test="barra-lingua" @update:model-value="cambiaLingua(String($event))" />
      <!-- Interruttore giorno/notte: l'onda di colore del cambio tema parte dal suo centro -->
      <div ref="contenitoreTema" class="inline-flex">
        <LayoutBarraTema :model-value="ui.isDarkTheme" :aria-label="t('layout.barra.tema_scuro')" data-test="barra-tema" @update:model-value="cambiaTema($event, contenitoreTema)" />
      </div>
      <NotificheCampanella />
    </div>
  </header>
</template>

<script setup lang="ts">
// Barra globale: marchio, campanella delle notifiche, lingua e tema (interruttore giorno/notte, con l'onda di colore di `useCambioTema`). La lingua si ricorda come faceva il menu laterale (`selectedLanguage`).
import { useI18n } from "vue-i18n";
import type { OpzioneSegmento } from "~/types/ui";

const { t, locale } = useI18n();
const { $localStorage } = useNuxtApp();
const ui = useUiStore();
const { cambiaTema } = useCambioTema();
// L'onda di colore del cambio tema parte dal centro di questo controllo
const contenitoreTema = ref<HTMLElement | null>(null);

const opzioniLingua: OpzioneSegmento<string>[] = LINGUE.map((l) => ({ value: l.value, label: l.value.toUpperCase(), ariaLabel: l.label }));

function cambiaLingua(codice: string): void {
  locale.value = codice;
  $localStorage.setItem("selectedLanguage", codice);
}
</script>
